import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "./ApiRequest";
const { Beverages } = require("./EndPoints");

// Schema dei campi (tipi ed etichette) di una categoria: lo decide il backend.
export const GetBeverageSchema = (section) => {
  return getRequest(`${Beverages.SCHEMA}?section=${section}`);
};
export const GetBeverages = (
  currentPage,
  pageSize,
  section = "",
  search = "",
  order = ""
) => {
  return getRequest(
    `${Beverages.BEVERAGES}?page=${currentPage}&per_page=${pageSize}&section=${section}&query=${encodeURIComponent(
      search
    )}&order=${order}`
  );
};
export const GetSingleBeverage = (id) => {
  return getRequest(`${Beverages.BEVERAGES}/${id}`);
};
export const CreateBeverage = (payload) => {
  return postRequest(Beverages.BEVERAGES, payload);
};
export const UpdateBeverage = (id, payload) => {
  return patchRequest(`${Beverages.BEVERAGES}/${id}`, payload);
};
export const DeleteBeverage = (id) => {
  return deleteRequest(`${Beverages.BEVERAGES}/${id}`);
};
// Bozza da foto dell'etichetta: non salva nulla.
export const BeverageAIDraft = (payload) => {
  return postRequest(Beverages.AI_DRAFT, payload);
};
